import { each } from 'lodash';
export default function calGroupBuyCard(opt) {
    const { card, activities } = opt;
    const activityProducts = [];
    each(activities, (activity) => {
        each(activity.products, (product) => {
            if (product.categoryNo === card.cardId.toString() && product.activityPrice > 0) {
                activityProducts.push({
                    activityId: product.activityId,
                    activityPrice: product.activityPrice,
                    categoryNo: product.categoryNo,
                    productNo: product.productNo,
                });
            }
        });
        if (activityProducts.length > 0) {
            return activityProducts;
        }
    });
    return activityProducts;
}
//# sourceMappingURL=calGroupBuyCard.js.map